import { useState, useEffect, useRef } from 'react';
import { Toaster } from '../Toast';
import './MultiSelect.scss';
let MAX_SELECTION = 1000;
function MultiSelect(props) {
	const [pageNo, setPageNo] = useState(1);
	useEffect(() => {
		setFilteredItem(props.data);
	}, [props.data]);
	useEffect(() => {}, [props.selectedItem]);
	// const [selectedItem, setSelectedItem] = useState(props.selectedItem || []);
	const [filteredItem, setFilteredItem] = useState(props.data);

	const multiselectRef = useRef();
	const handleClick = (e) => {
		if (multiselectRef.current && !multiselectRef.current.contains(e.target)) {
			if (document.getElementById('multiSelectContainer')) {
				document.getElementById('multiSelectContainer').style.display = 'none';
			}
		}
	};

	useEffect(() => {
		document.addEventListener('click', handleClick);

		return () => {
			document.removeEventListener('click', handleClick);
		};
	});

	const selectItem = (item) => {
		let prevData = props.selectedItem;
		let checkResult = prevData.find((prevItem) => prevItem === item);
		// let checkResult = prevData.find(
		// 	(prevItem) => prevItem[props.operationKey] === item[props.operationKey]
		// );
		if (checkResult) {
			// setSelectedItem(prevData.filter((e) => e[props.operationKey] !== item[props.operationKey]));
			props.onSelect(prevData.filter((e) => e !== item));
		} else {
			// setSelectedItem([...prevData, item]);
			props.onSelect([...prevData, item]);
		}
	};
	const searchItem = (key) => {
		if (key.includes(':')) {
			if (key === ':all') {
				selectAll();
				Toaster.success({
					title: 'Cheat code applied 😉',
					message: '🤫 Keep it to yourself ',
				});
			}
		} else {
			let data = props.data;
			let searchedItem = [];
			for (let idx in data) {
				if (data[idx][props.displayKey].toLowerCase().includes(key.toLowerCase())) {
					searchedItem.push(data[idx]);
				}
			}
			setFilteredItem(searchedItem);
		}
	};
	const selectAll = () => {
		// setSelectedItem(
		// 	props.data.map((vehicle) => {
		// 		return vehicle.vehicleid;
		// 	})
		// );
		props.onSelect(
			filteredItem.map((vehicle) => {
				return vehicle.vehicleid;
			})
		);
	};
	const clearAll = () => {
		// setSelectedItem([]);
		props.onSelect([]);
		setPageNo(0);
	};
	const toggleMultiSelect = () => {
		if (document.getElementById('multiSelectContainer')) {
			document.getElementById('multiSelectContainer').style.display = 'flex';
		}
	};

	const checkIfSelect = (vehicleid) => {
		// return props.selectedItem.find((item) => item[props.operationKey] === vehicleid);
		return props.selectedItem.find((item) => item === vehicleid);
	};

	const closeMultiSelect = () => {
		if (document.getElementById('multiSelectContainer')) {
			document.getElementById('multiSelectContainer').style.display = 'none';
		}
	};

	const processedItems = () => {
		let items = [];
		let oldItems = [...filteredItem];
		for (let idx in filteredItem) {
			if (checkIfSelect(filteredItem[idx][props.operationKey])) {
				items.push(filteredItem[idx]);
				let index = oldItems.findIndex(
					(x) => x[props.operationKey] === filteredItem[idx][props.operationKey]
				);
				if (index !== -1) {
					oldItems.splice(index, 1);
				}
			}
		}
		return [...items, ...oldItems];
	};

	const paginateVehicle = (array, page_size, page_number) => {
		return array.slice((page_number - 1) * page_size, page_number * page_size);
	};
	const selectNext = () => {
		let next = paginateVehicle(props.data, MAX_SELECTION, pageNo + 1);
		setPageNo(pageNo + 1);
		props.onSelect(
			next.map((vehicle) => {
				return vehicle.vehicleid;
			})
		);
		if (props.paginate) {
			props.paginate(pageNo + 1);
		}
	};
	const selectPrev = () => {
		let prev = paginateVehicle(props.data, MAX_SELECTION, pageNo - 1);
		setPageNo(pageNo - 1);
		props.onSelect(
			prev.map((vehicle) => {
				return vehicle.vehicleid;
			})
		);
		if (props.paginate) {
			props.paginate(pageNo - 1);
		}
	};
	return (
		<div className="MultiSelect" ref={multiselectRef}>
			<div className="InputLabel" onClick={toggleMultiSelect}>
				{props.loading ? (
					<span>loading ...</span>
				) : (
					<span>
						selected {props.selectedItem.length} of {props.data.length}
					</span>
				)}
				<i className="far fa-caret-circle-down"></i>
			</div>
			<div className="ItemListContainer" id="multiSelectContainer">
				<div className="SearchBoxContainer">
					<div className="BoxContainer">
						<i className="fa fa-search"></i>
						<input
							type="text"
							placeholder={`Search `}
							onChange={(e) => searchItem(e.target.value)}
						/>
					</div>
				</div>
				<small style={{ fontSize: 10, padding: '0 10px' }}>
					{pageNo === 0
						? 'Selected none'
						: `Selected from 
						  (${pageNo === 1 || pageNo === 0 ? 1 : (pageNo - 1) * MAX_SELECTION + 1} - ${
								pageNo * MAX_SELECTION
						  })`}
				</small>

				<div className="ItemList">
					{processedItems().map((item, key) => {
						return (
							<div
								className={'Item ' + (checkIfSelect(item[props.operationKey]) && 'active')}
								key={key}
								onClick={() => selectItem(item[props.operationKey])}
							>
								<div>{parseInt(key) + 1}</div>
								<span>{item[props.displayKey]}</span>
							</div>
						);
					})}
				</div>
				<div className="mainAction">
					<div className="Row">
						{props.inBlock ? (
							<>
								<button onClick={selectPrev} disabled={pageNo === 1 || pageNo === 0}>
									{'Prev 1K'}
								</button>
								<button onClick={selectNext}>{'Next 1K'}</button>
							</>
						) : (
							<button onClick={selectAll}>ALL</button>
						)}
						{/* <button onClick={selectAll}>ALL</button> */}
						<button onClick={clearAll}>CLEAR</button>
					</div>
					<div className="Row">
						<button style={{ background: '#EB5971', color: 'white' }} onClick={closeMultiSelect}>
							OK
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}

export default MultiSelect;
